(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("emlogin", [], factory);
	else if(typeof exports === 'object')
		exports["emlogin"] = factory();
	else
		root["emlogin"] = factory();
})(window, function() {
return 